import styled from 'styled-components';

import { Theme } from '@/shared/themes';

export const Title = styled.h3`
  width: 100%;
  text-align: center;
  font-size: 72px;
  margin-bottom: 48px;
  font-weight: 400;
  font-family: ${({ theme }: { theme: Theme }) => theme.fonts.gramatika};
`;
